import * as React from "react";
import { Fragment, useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { Auth, Hub } from "aws-amplify";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import InfoIcon from "@mui/icons-material/Info";
import logo from "./images/logo.png";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";

const BootstrapButton = styled(Button)({
  boxShadow: "none",
  textTransform: "none",
  fontSize: "16px",
  padding: "6px 12px",
  border: "1px solid",
  lineHeight: 1.5,
  backgroundColor: "#303234",
  borderColor: "#303234",
  whiteSpace: "nowrap",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
  "&:hover .MuiButton-root": {
    backgroundColor: "white !important",
    borderColor: "white",
    boxShadow: "none",
  },
});

const StyledMenu = styled(Menu)(({ theme }) => ({
  ".MuiPaper-root": {
    backgroundColor: "#303234",
    color: "white",
    boxShadow: "none",
  },
}));

const HomeBar = React.memo((props) => {
  useEffect(() => {
    checkUser();
    Hub.listen("auth", (data) => {
      const { payload } = data;
      if (payload.event === "signOut") {
        setUser(null);
      }
    });
  }, []);
  const [user, setUser] = useState(null);

  const navigate = useNavigate();

  window.addEventListener("popstate", function (e) {
    navigate("/"); // 現在のパスに再度遷移
  });

  async function checkUser() {
    try {
      const data = await Auth.currentUserPoolUser();
      const userInfo = { username: data.username, ...data.attributes };
      setUser(userInfo);
      Auth.currentSession().then().catch();
    } catch (err) {}
  }
  function signOut() {
    Auth.signOut().catch();
  }
  function removeElementsByClass(className, length) {
    const elements = document.getElementsByClassName(className);
    while (elements.length > length) {
      elements[0].parentNode.removeChild(elements[0]);
    }
  }

  const [anchorElMydata, setAnchorElMydata] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  if (user) {
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };

    const openMydata = Boolean(anchorElMydata);
    const handleClickMydata = (event) => {
      setAnchorElMydata(event.currentTarget);
      removeElementsByClass("cytoscape-navigator", 0);
    };
    const handleCloseMydata = () => {
      setAnchorElMydata(null);
    };

    return (
      <Fragment>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            textAlign: "center",
            backgroundColor: "#303234",
            flexGrow: 1,
            height: "80px",
            position: "sticky",
            top: "0",
            zIndex: "5",
            minWidth: "1200px",
          }}
        >
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            sx={{
              flexWrap: "nowrap",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Grid
              item
              style={{
                textAlign: "left",
                alignItems: "center",
                paddingLeft: "10px",
                width: "25%",
              }}
            >
              <NavLink
                style={{
                  textDecoration: "none",
                  width: "200px",
                  padding: "10px",
                }}
                to="/home"
                onClick={() => removeElementsByClass("cytoscape-navigator", 0)}
              >
                <img
                  alt="ロゴ"
                  src={logo}
                  style={{
                    height: "25px",
                    marginLeft: "16px",
                    marginTop: "8px",
                    backgroundColor: "transparent",
                  }}
                />
              </NavLink>
            </Grid>
            <Grid
              item
              style={{
                height: "50px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "12%",
              }}
              sx={{
                borderRadius: "5px",
                backgroundColor:
                  String(window.location.hash).indexOf("datalist") >= 0 ||
                  String(window.location.hash).indexOf("dataJacket") >= 0
                    ? "#75787B !important"
                    : "",
                ".child": {
                  borderBottom:
                    String(window.location.hash).indexOf("datalist") >= 0 ||
                    String(window.location.hash).indexOf("dataJacket") >= 0
                      ? "3px solid #26890D"
                      : "",
                },
                "&:hover": {
                  backgroundColor: "#75787B !important",
                  "&:hover .child": {
                    borderBottom: "3px solid #26890D",
                  },
                },
              }}
            >
              <BootstrapButton
                className="child"
                sx={{
                  height: "30px",
                  minWidth: 100,
                  color: "white",
                  fontWeight: "600",
                  border: 0,
                  backgroundColor: "transparent",
                  borderRadius: 0,
                }}
                component={NavLink}
                to="/datalist"
                onClick={() => removeElementsByClass("cytoscape-navigator", 0)}
              >
                DATA JACKET
              </BootstrapButton>
            </Grid>
            <Grid
              item
              style={{
                height: "50px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "12%",
              }}
              sx={{
                borderRadius: "5px",
                backgroundColor:
                  String(window.location.hash).indexOf("graph") >= 0
                    ? "#75787B !important"
                    : "",
                ".child": {
                  borderBottom:
                    String(window.location.hash).indexOf("graph") >= 0
                      ? "3px solid #26890D"
                      : "",
                },
                "&:hover": {
                  backgroundColor: "#75787B !important",
                  "&:hover .child": {
                    borderBottom: "3px solid #26890D",
                  },
                },
              }}
            >
              <BootstrapButton
                className="child"
                sx={{
                  height: "30px",
                  minWidth: 100,
                  color: "white",
                  fontWeight: "600",
                  border: 0,
                  backgroundColor: "transparent",
                  borderRadius: 0,
                }}
                component={NavLink}
                to="/graph"
                onClick={() => {
                  removeElementsByClass("cytoscape-navigator", 0);
                  if (props.setOpen !== undefined) {
                    props.setOpen(true);
                    props.setDisplay(false);
                  }
                }}
              >
                CONNECT DJ
              </BootstrapButton>
            </Grid>
            <Grid
              item
              style={{
                height: "50px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "12%",
              }}
              sx={{
                borderRadius: "5px",
                backgroundColor:
                  String(window.location.hash).indexOf("mydata") >= 0
                    ? "#75787B !important"
                    : "",
                ".child": {
                  borderBottom:
                    String(window.location.hash).indexOf("mydata") >= 0
                      ? "3px solid #26890D"
                      : "",
                },
                "&:hover": {
                  backgroundColor: "#75787B !important",
                  "&:hover .child": {
                    borderBottom: "3px solid #26890D",
                  },
                },
              }}
            >
              <BootstrapButton
                className="child"
                sx={{
                  height: "30px",
                  minWidth: 100,
                  color: "white",
                  fontWeight: "600",
                  border: 0,
                  backgroundColor: "transparent",
                  borderRadius: 0,
                }}
                id="demo-positioned-button"
                ariaControls={openMydata ? "demo-positioned-menu" : undefined}
                ariaHaspopup="true"
                ariaExpanded={openMydata ? "true" : undefined}
                onClick={handleClickMydata}
              >
                MY DATA
              </BootstrapButton>
              <StyledMenu
                id="demo-positioned-menu"
                aria-labelledby="demo-positioned-button"
                anchorEl={anchorElMydata}
                open={openMydata}
                onClose={handleCloseMydata}
                onClick={() => removeElementsByClass("cytoscape-navigator", 0)}
                disablePortal
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: -10,
                  horizontal: 50,
                }}
              >
                <MenuItem
                  component={NavLink}
                  to="/mydata/connectdj"
                  onClick={handleCloseMydata}
                  style={{
                    margin: "0 30px",
                    justifyContent: "center",
                    borderRadius: "5px",
                    fontFamily: "Noto Sans JP, Meiryo, -apple-system",
                  }}
                  sx={{
                    "&:hover": {
                      backgroundColor: "#75787B !important",
                    },
                  }}
                >
                  CONNECT DJ
                </MenuItem>
                <MenuItem
                  component={NavLink}
                  to="/mydata/datajacket"
                  onClick={handleCloseMydata}
                  style={{
                    margin: "0 30px",
                    justifyContent: "center",
                    borderRadius: "5px",
                    fontFamily: "Noto Sans JP, Meiryo, -apple-system",
                  }}
                  sx={{
                    "&:hover": {
                      backgroundColor: "#75787B !important",
                    },
                  }}
                >
                  DATA JACKET
                </MenuItem>
              </StyledMenu>
            </Grid>
            <Grid
              item
              style={{
                height: "50px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "12%",
              }}
              sx={{
                borderRadius: "5px",
                backgroundColor:
                  String(window.location.hash).indexOf("contact") >= 0
                    ? "#75787B !important"
                    : "",
                ".child": {
                  borderBottom:
                    String(window.location.hash).indexOf("contact") >= 0
                      ? "3px solid #26890D"
                      : "",
                },
                "&:hover": {
                  backgroundColor: "#75787B !important",
                  "&:hover .child": {
                    borderBottom: "3px solid #26890D",
                  },
                },
              }}
            >
              <BootstrapButton
                className="child"
                sx={{
                  height: "30px",
                  minWidth: 100,
                  color: "white",
                  fontWeight: "600",
                  border: 0,
                  backgroundColor: "transparent",
                  borderRadius: 0,
                }}
                component={NavLink}
                to="/contact"
                onClick={() => removeElementsByClass("cytoscape-navigator", 0)}
              >
                CONTACT
              </BootstrapButton>
            </Grid>
            <Grid
              item
              style={{
                textAlign: "right",
                display: "flex",
                justifyContent: "right",
                width: "15%",
              }}
            >
              <Tooltip title="アカウントメニュー">
                <IconButton
                  onClick={handleClick}
                  size="small"
                  sx={{ ml: 2, marginRight: "16px", paddingTop: "0px" }}
                  aria-controls={open ? "account-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                >
                  <Avatar sx={{ width: 32, height: 32 }}></Avatar>
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </div>
        <Divider
          style={{
            backgroundColor: "white",
            position: "sticky",
            zIndex: "4",
            top: "80px",
            minWidth: "1200px",
          }}
        />
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              backgroundColor: "#53565A",
              color: "white",
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "#53565A",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <MenuItem
            style={{ fontFamily: "Noto Sans JP, Meiryo, -apple-system" }}
          >
            <ListItemIcon>
              <InfoIcon />
            </ListItemIcon>{" "}
            ID: {user.email}
          </MenuItem>
          <NavLink
            to="/changepassword"
            state={{ formType: "changePassword" }}
            style={{ textDecoration: "none", color: "white" }}
          >
            <MenuItem
              style={{ fontFamily: "Noto Sans JP, Meiryo, -apple-system" }}
              onClick={() => {
                removeElementsByClass("cytoscape-navigator", 0);
                handleClose();
              }}
            >
              <ListItemIcon>
                <Settings fontSize="small" />
              </ListItemIcon>
              パスワード変更
            </MenuItem>
          </NavLink>
          <NavLink to="/" style={{ textDecoration: "none", color: "white" }}>
            <MenuItem
              style={{ fontFamily: "Noto Sans JP, Meiryo, -apple-system" }}
              onClick={() => {
                removeElementsByClass("cytoscape-navigator", 0);
                signOut();
              }}
            >
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              Logout
            </MenuItem>
          </NavLink>
        </Menu>
      </Fragment>
    );
  }
});

export default HomeBar;
